import { useCompanyContext } from '@/components/company-shell';
import { LineSetup } from '@/components/line-setup';

/**
 * Page `/company/:companyId/channel-onboarding` — "Alta de línea" tab.
 * Reads the shell context and renders the `LineSetup` screen for the
 * loaded company.
 */
export const ChannelOnboardingPage = () => {
  const { company, refetch } = useCompanyContext();

  return <LineSetup company={company} refetch={refetch} />;
};
